






































































































































































import {Component, Vue, Watch} from 'vue-property-decorator';
import IconButton from '@c/controls/IconButton.vue';
import SelectionList from '@c/controls/selectionList/SelectionList.vue';
import DragList from '@c/controls/dragList/DragList.vue';
import Card from '@c/Card.vue';
import draggable from 'vuedraggable';
import DAssistanceSignalDiagramBox from '@/components/services/diagnosticAssistance/DAssistanceSignalDiagramBox.vue';
import DAssistanceSpectrumDiagramBox from '@/components/services/diagnosticAssistance/DAssistanceSpectrumDiagramBox.vue';
import {uuidv4} from '@/utils/uuidUtils';
import signalDiagramModule from '@/store/modules/signalDiagramModule';
import spectrumDiagramModule from '@/store/modules/spectrumDiagramModule';
import {
  SelectionListFilterModel,
  SelectionListGroupingModel,
} from '@/components/controls/selectionList/interfaces';
import {pmoduleTypeFilter} from '@/components/nodeComponent/filters';
import {pmoduleGroupings} from '@/components/nodeComponent/groupings';
import {Splitpanes, Pane} from 'splitpanes';
import 'splitpanes/dist/splitpanes.css';
import SplitList from '@c/controls/SplitList.vue';
import Loading from '@c/controls/Loading.vue';
import SimpleDialog from '@c/SimpleDialog.vue';
import {Can} from '@casl/vue';
import diagnosticAssistanceStoreModule from '@/store/modules/services/diagnosticAssistanceModule';
import {
  getAllModules,
  getModulesByGuids,
} from '@/store/modules/entities/pmodules/pmoduleWithMeasurementsModule';
import {PModuleWithMeasurements} from '@/views/system/modules/interfaces';
import measurementsModule from '@/store/modules/entities/measurementsModule';
import {PModuleType} from '@/enums/configs';
import {DiagramData} from '@/components/diagrams/interfaces';
import {MeasurementType} from '@/views/system/measurements/enums';
import {MeasurementData} from '@/views/system/measurements/interfaces';
import {getSignalDiagramTitle, getSpectrumDiagramTitle} from '@/components/diagrams/utils';
import userSettingsStoreModule from '@/store/modules/userSettingsModule';
import {SpectrumDiagramSettings} from '../vibrationDiagnostic/interfaces';
import {DiagnosticAssistanceDiagram} from '@/views/services/diagnosticAssistance/interfaces';

@Component({
  components: {
    IconButton,
    SelectionList,
    DragList,
    Card,
    draggable,
    DAssistanceSignalDiagramBox,
    DAssistanceSpectrumDiagramBox,
    Splitpanes,
    Pane,
    SplitList,
    Loading,
    SimpleDialog,
    Can,
  },
})
export default class DiagnosticAssistance extends Vue {
  // id model
  id!: number;

  // Модель кнопки редактирования
  editButton = false;

  nonEmptyTextRule = (v: any) => !!v || (v && v.length === 0) || 'Поле обязательно для заполнения';

  saveHint = false;
  textHint = 'Набор сохранен';

  valid = true;

  loading = false;
  error = false;

  // Цвет кнопки редактирования
  get editButtonColor() {
    return this.edit ? 'red' : 'blue';
  }

  // Список диаграмм в диалоге перемещения
  dragDialogDiagramMap: any = {};

  // Копирование списка диаграмм перед открытием диалога
  @Watch('dragDialog')
  onDragDialog(value: boolean) {
    if (value) this.dragDialogDiagramMap = {...this.diagramsMap};
    else this.dragDialogDiagramMap = {};
  }

  // Действия при подтверждении порядка диаграмм
  onDragSelect() {
    this.dragDialog = false;
    this.diagramsMap = {...this.dragDialogDiagramMap};
  }

  // Список программных модулей
  pmodules: PModuleWithMeasurements[] = [];

  // Фильтр программных модулей по типу
  pmoduleTypeFilter: SelectionListFilterModel = pmoduleTypeFilter;

  // Список группировок программных модулей
  pmoduleGroupings: SelectionListGroupingModel[] = pmoduleGroupings;

  // Диалоговое окно для выбора программных модулей
  pmodulesDialog = false;

  // Диалоговое окно для изменения порядка графиков
  dragDialog = false;

  // Список выбранных программных модулей
  selectedPModulesGuids: string[] = [];

  // Имя набора графиков
  collectionName = '';

  // Статус кнопки "подтверждения" в диалоговом окне сохранения набора
  statusSaveDialogButton = false;

  // Сохраняем выбранные идентификаторы при открытии диалога
  dialogSelectedPModulesGuids: string[] = [];
  @Watch('pmodulesDialog')
  onConfigsDialog(value: boolean) {
    if (value) this.dialogSelectedPModulesGuids = [...this.selectedPModulesGuids];
  }

  // Показатель режима редактирования
  edit = false;

  // Ключ для перерисовки диаграмм
  resizedKey = 0;

  // Показатель, того что на странице нет графиков
  get isEmpty() {
    return !Object.keys(this.diagramsMap).length;
  }

  get selectedPModules() {
    return this.pmodules.filter((x: any) => this.selectedPModulesGuids.includes(x.guid));
  }

  //Данные методы isSignal и isSpectrum нужны из-за того, что vue темплейты не понимают enums
  isSignal(d: DiagramData) {
    return d.measurementType === MeasurementType.Signal;
  }

  isSpectrum(d: DiagramData) {
    return d.measurementType === MeasurementType.Spectrum;
  }

  // Модель колонок
  oneColumn = [
    {
      id: '1',
      size: 50,
    },
  ];

  twoColumns = [
    {
      id: '1',
      size: 50,
    },
    {id: '2', size: 50},
  ];

  columns = this.oneColumn;

  diagramsMap: Record<string, DiagramData[]> = {};

  // Распределение элементов по колонкам
  arrangeItems(newItems: any[] = []) {
    //равномерно перераспределяем
    let items: any[] = [];
    for (const key in this.diagramsMap) items = items.concat(this.diagramsMap[key]);

    if (newItems.length) items = newItems;

    const сolumnCount = Math.round(items.length / this.columns.length);
    const lastColumnCount = items.length - сolumnCount * (this.columns.length - 1);

    const counts = [...Array(this.columns.length - 1).keys()].map(() => сolumnCount);
    counts.push(lastColumnCount);

    const newItemsMap: Record<string, any[]> = {};
    let index = 0;
    this.columns.forEach((c: any, i: number) => {
      const columnItems: any[] = [];
      for (let j = 0; j < counts[i]; ++j) {
        columnItems.push(items[index]);
        index++;
      }
      newItemsMap[c.id] = columnItems;
    });

    this.diagramsMap = newItemsMap;
  }

  // Распределение элементов по заданным местам
  placeItems(newItems: DiagnosticAssistanceDiagram[] = []) {
    const newItemsMap: Record<string, any[]> = {};
    this.columns.forEach((c: any) => {
      newItemsMap[c.id] = newItems
        .filter(item => item.column == c.id)
        .sort((a, b) => (a.position > b.position && 1) || -1)
        .map(item => item.diagram);
    });
    this.diagramsMap = newItemsMap;
  }

  //Изменить модель колонок
  changeColumnModel() {
    if (this.columns.length === 1) this.columns = this.twoColumns;
    else this.columns = this.oneColumn;
    this.arrangeItems();
  }

  // Действия при удалении карточки графика
  onRemove(diagram: any) {
    const filteredDiagramsMap: Record<string, DiagramData[]> = {};
    for (const key in this.diagramsMap)
      filteredDiagramsMap[key] = this.diagramsMap[key].filter(x => x.id !== diagram.id);
    this.diagramsMap = filteredDiagramsMap;

    if (this.isEmpty) this.edit = false;
    this.selectedPModulesGuids = [...new Set(this.diagrams.map(item => item.moduleGUID))];
  }

  // Загрузка программных модулей
  pmodulesLoading = true;
  pmodulesError = false;
  async loadPModules() {
    try {
      this.pmodulesLoading = true;
      this.pmodulesError = false;
      const pmodules = await getAllModules();
      this.pmodules = pmodules.filter(x => x.measurements);
    } catch (e) {
      console.log(e);
      this.pmodulesError = true;
    } finally {
      this.pmodulesLoading = false;
    }
  }

  transformDiagram(diagram: SpectrumDiagramSettings): DiagramData | undefined {
    const pmodule = this.pmodules.filter(y => diagram.moduleGUID === y.guid)[0];
    if (!pmodule || diagram.measurementId === undefined) return;
    const measurement = this.getMeasurementById(diagram.measurementId);
    if (!measurement) return;
    const moduleId = pmodule?.id as number;
    const moduleType = pmodule?.type as PModuleType;
    const moduleName = pmodule.name;

    if (measurement.type === MeasurementType.Signal) {
      return {
        id: uuidv4(),
        name: `${moduleName}: ${getSignalDiagramTitle(measurement)}`,
        moduleId: moduleId,
        moduleGUID: diagram.moduleGUID,
        moduleType: moduleType,
        measurement: measurement,
        measurementName: getSignalDiagramTitle(measurement),
        moduleName: moduleName,
        topBoundary: measurement.topWarningBoundary,
        bottomBoundary: measurement.bottomWarningBoundary,
        measurementType: MeasurementType.Signal,
        color: diagram.color,
        freqbandId: diagram.freqbandId,
        isYLogAxis: diagram.isYLogAxis,
        hideZeroFrequency: diagram.hideZeroFrequency,
      };
    }
    // measurement.type === MeasurementType.Spectrum
    return {
      id: uuidv4(),
      name: `${moduleName}: ${getSpectrumDiagramTitle(measurement)}`,
      moduleId: moduleId,
      moduleGUID: diagram.moduleGUID,
      moduleType: moduleType,
      measurementName: getSpectrumDiagramTitle(measurement),
      moduleName: moduleName,
      measurement: measurement,
      measurementType: MeasurementType.Spectrum,
      color: diagram.color,
      freqbandId: diagram.freqbandId,
      isYLogAxis: diagram.isYLogAxis,
      hideZeroFrequency: diagram.hideZeroFrequency,
    };
  }

  async loadModel() {
    try {
      this.loading = true;
      const {data} = await diagnosticAssistanceStoreModule.edit(this.id);

      if (data) {
        this.collectionName = data.name;
        this.statusSaveDialogButton = true;

        this.columns = data.columns;

        this.selectedPModulesGuids = [
          ...new Set(data.diagrams.map(item => item.diagram.moduleGUID)),
        ];
        const transformedDiagrams: DiagnosticAssistanceDiagram[] = data.diagrams.map(
          item =>
            ({
              ...item,
              diagram: this.transformDiagram(item.diagram),
            } as DiagnosticAssistanceDiagram),
        );

        this.placeItems(transformedDiagrams);
      }
    } catch (e) {
      console.log(e);
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  // Получить измерение по id
  getMeasurementById(id: number) {
    const data = this.measurements.filter(x => x.id === id);
    if (data.length) return data[0];
    return null;
  }

  // Диаграммы
  get diagrams() {
    let diagrams: DiagramData[] = [];
    for (const key in this.diagramsMap) diagrams = diagrams.concat(this.diagramsMap[key]);
    return diagrams;
  }

  /*
     Загрузка измерений, измерение = график
  */
  diagramsLoading = false;
  diagramsError = false;
  async loadDiagrams() {
    try {
      this.diagramsLoading = true;
      this.diagramsError = false;

      const guids = this.selectedPModules.map(c => c.guid as string);

      const diagramList: DiagramData[] = [];
      const data = await getModulesByGuids(guids);

      data.forEach((pmodule: PModuleWithMeasurements) => {
        const moduleId = pmodule?.id as number;
        const moduleGUID = pmodule?.guid as string;
        const moduleType = pmodule?.type as PModuleType;
        const moduleName = pmodule?.name as string;

        pmodule.measurements.forEach(x => {
          if (!x.measurementId) return;

          const measurement = this.getMeasurementById(x.measurementId);
          if (!measurement) return;

          if (measurement.type === MeasurementType.Signal)
            diagramList.push({
              id: uuidv4(),
              name: `${moduleName}: ${getSignalDiagramTitle(measurement)}`,
              moduleId: moduleId,
              moduleGUID: moduleGUID,
              moduleType: moduleType,
              measurement: measurement,
              measurementName: getSignalDiagramTitle(measurement),
              moduleName: moduleName,
              topBoundary: measurement.topWarningBoundary,
              bottomBoundary: measurement.bottomWarningBoundary,
              measurementType: MeasurementType.Signal,
            });

          if (measurement.type === MeasurementType.Spectrum)
            diagramList.push({
              id: uuidv4(),
              name: `${moduleName}: ${getSpectrumDiagramTitle(measurement)}`,
              moduleId: moduleId,
              moduleGUID: moduleGUID,
              moduleType: moduleType,
              measurementName: getSpectrumDiagramTitle(measurement),
              moduleName: moduleName,
              measurement: measurement,
              measurementType: MeasurementType.Spectrum,
            });
        });
      });

      //убираем из diagrams те диаграммы, которых нет в diagramList
      const removedDiagrams = this.diagrams.filter(
        x => !diagramList.some(y => this.isEqualDiagrams(x, y)),
      );

      //добавляем в diagrams те диаграммы, которые есть в diagramList, но нет в diagrams
      const addedDiagrams = diagramList.filter(
        x => !this.diagrams.some(y => this.isEqualDiagrams(x, y)),
      );

      //обновляем список диаграмм
      const diagrams = this.diagrams
        .filter(x => !removedDiagrams.includes(x))
        .concat(addedDiagrams);

      //распределяем диаграммы по колонкам
      this.diagramsMap = {};
      this.arrangeItems(diagrams);
    } catch {
      this.diagramsError = true;
    } finally {
      this.diagramsLoading = false;
    }
  }

  @Watch('diagrams')
  onDiagramsChange(value: DiagramData[]) {
    signalDiagramModule.setCanSync({diagrams: value.filter(x => this.isSignal(x))});
    spectrumDiagramModule.setCanSync({diagrams: value.filter(x => this.isSpectrum(x))});
  }

  isEqualDiagrams(x: DiagramData, y: DiagramData) {
    return y.moduleGUID === x.moduleGUID && y.name === x.name;
  }

  //TODO: Убрать
  getAppropriateDiagrams(diagram: DiagramData) {
    //TODO: Нужен фильтр диаграмм по оси X
    return this.diagrams.filter(
      x => x.id !== diagram.id && x.measurementType === diagram.measurementType,
    );
  }

  //Действия при выборе программных модулей
  onSelectPModules() {
    this.selectedPModulesGuids = [...this.dialogSelectedPModulesGuids];
    this.pmodulesDialog = false;
    this.loadDiagrams();
  }

  @Watch('collectionName')
  onChangedSetName(newVal: string) {
    if (newVal && this.diagrams.length > 0) this.statusSaveDialogButton = true;
  }

  async onSaveCollection() {
    this.loading = true;
    this.valid = await (this.$refs.form as any).validate();

    if (!this.valid) {
      const error = document.querySelector('div.error--text');
      error && this.$vuetify.goTo(error as HTMLElement);
      this.textHint = 'Укажите название набора';
      this.saveHint = true;
      this.loading = false;
      return;
    }

    const diagrams: any[] = [];
    for (const [key, value] of Object.entries(this.diagramsMap)) {
      value.map((el, index) => {
        diagrams.push({
          diagram: el,
          position: index,
          column: key,
        });
      });
    }

    const diagramsWithSettings: DiagnosticAssistanceDiagram[] = await Promise.all(
      diagrams.map(async diagramContainer => {
        const diagram = diagramContainer.diagram;
        const diagramSetting = await userSettingsStoreModule.getTempDiagramSettings({
          pModuleId: diagram.moduleId,
          measurementId: diagram.measurement.id,
          measurementType: diagram.measurementType,
        });
        return {
          ...diagramContainer,
          diagram: {
            moduleGUID: diagram.moduleGUID,
            measurementId: diagram.measurement.id,
            color: diagramSetting?.color ?? diagram.color,
            freqbandId: diagramSetting?.freqbandId ?? diagram.freqbandId,
            isYLogAxis: diagramSetting?.isYLogAxis ?? diagram.isYLogAxis,
            hideZeroFrequency: diagramSetting?.hideZeroFrequency ?? diagram.hideZeroFrequency,
          },
        };
      }),
    );

    try {
      await diagnosticAssistanceStoreModule.save({
        id: this.id,
        name: this.collectionName,
        diagrams: diagramsWithSettings,
        columns: this.columns,
      });
      this.textHint = 'Набор сохранен';
    } catch {
      this.textHint = 'Произошла ошибка';
    } finally {
      this.saveHint = true;
      this.loading = false;
    }
  }

  measurements: MeasurementData[] = [];

  async created() {
    try {
      await this.loadPModules();

      await measurementsModule.fetchAll();
      this.measurements = [...measurementsModule.all];

      if (this.$route.params.id) {
        this.id = parseInt(this.$route.params.id);
        this.loadModel();
      }
    } catch (e) {
      console.log(e);
    }
  }

  beforeDestroy() {
    userSettingsStoreModule.clearTempDiagramSettings();
    signalDiagramModule.clear();
    spectrumDiagramModule.clear();
  }

  mounted() {
    //хак для обновления диаграммы, после ресайза сплиттера. Событие @ready на сплиттере не работает, т. к. не синхронизированно с vuetify
    this.$nextTick(() => {
      this.resizedKey++;
    });
  }
}
